import { render, staticRenderFns } from "./ContestAdmin.vue?vue&type=template&id=0977b138&scoped=true&"
import script from "./ContestAdmin.vue?vue&type=script&lang=ts&"
export * from "./ContestAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977b138",
  null
  
)

export default component.exports